import { humanize } from 'common/helpers/humanize';
import { slugify } from 'common/utils/slug';
import {
  getLocationTypeLabel,
  locationTypeKeyFromId,
  toLocationTypeKey
} from 'common/utils/locationTypeKey';

/**
 * Localized location name for builder / machine info views.
 *
 * @param {function} t - i18next `t`
 * @param {{ name?: string, location_type_id?: number|string|boolean }} item
 * @param {Array<{ text?: string, value?: number }>} [availableLocationTypes]
 */
export function getLocationDisplayName(t, item, availableLocationTypes = []) {
  const name = item && item.name ? item.name : '';
  const key =
    locationTypeKeyFromId(item && item.location_type_id, availableLocationTypes) ||
    toLocationTypeKey(name);

  // Only the type's own name localizes; a renamed location ("Motor1 Free End") stays verbatim.
  if (key && slugify(name) === key) {
    return getLocationTypeLabel(t, key, name);
  }

  return humanize(name);
}

/**
 * Location label for devices/sensors list. Short codes (e.g. L1) are shown as-is;
 * descriptive names are localized via location type translations.
 *
 * @param {function} t - i18next `t`
 * @param {string} [location]
 * @param {string} [locationDescription]
 * @returns {string}
 */
export function getSensorLocationDisplayText(t, location, locationDescription) {
  if (!location && !locationDescription) {
    return '';
  }

  const localizedName = name =>
    getLocationDisplayName(t, { name: humanize(name) || name });

  if (locationDescription && location && location.length < 4) {
    return `${humanize(location)} - ${localizedName(locationDescription)}`;
  }

  if (location) {
    return location.length < 4 ? humanize(location) : localizedName(location);
  }

  return localizedName(locationDescription);
}
